export const Route = {
  home: "/",
  post: "/post",
  login: "/login",
};

export default Route;
